/**
 *
 * "Provides a group object consists of sideliners and panels, \
 * and control their zoom in 2D plane for mobile version"
 *
 * @file   mobileDeckCanvas\DeckModel.js
 * @author Lateral
 * @since  2023
 */
import { Box, Stack } from '@mui/material'
import React, { useMemo } from 'react'
import { DeckPanels } from './DeckPanels'
import { RowNumbers } from './RowNumbers'
import { SideLiner } from './SideLiners'

const scale = 1

export function DeckModelReportPre({
  data,
  maintenance,
  materialSelected,
  onPanelClick,
  mode,
  presentation = false,
  heatMapData,
  selected,
  deckId
}) {
  /**
   * Provides a 2D structure with sideliners and panels and control their zoom and rotation.
   *
   * @function
   * @param {object} data - Deck rivision object from database
   * @param {object} maintenance - Deck Revision Histories
   * @param {number} materialSelected - Material number
   * @param {Function} onPanelClick - Action on clicking panel
   * @param {object[]} selected - Array of selected panel objects
   * @param {string} mode - Deck modes:   'default', 'edit', 'maintenance', 'heatmap', 'maintnance', 'pre-maintenance', 'post-maintenance'
   * @param {boolean} presentation - Mintenance mode presentation True to view higher contrast  text
   *
   * @returns {object} - React box element of deck model with deck components
   */

  const sideLiners = useMemo(() => {
    if (!data) {
      return {
        left: [],
        right: []
      }
    }
    const sideLiners = structuredClone(data.SideLiners).sort((a, b) => a.StartPosition - b.StartPosition)
    return { left: sideLiners.filter((d) => d.Side === 'Left'), right: sideLiners.filter((d) => d.Side === 'Right') }
  }, [data?.SideLiners])
  return (
    <Box sx={{ width: 'fit-content', margin: 'auto', alignItems: 'center', paddingTop: '1em' }}>
      <Stack spacing={1} sx={{ alignItems: 'center', paddingTop: '1em' }}>
        <Stack direction="row" id={deckId} justifyContent="center" alignItems="center" sx={{ height: '100%' }}>
          <RowNumbers scale={scale} totalRows={data.Size.Rows} presentation={presentation} />
          <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'center' }}>
            <SideLiner
              data={sideLiners.right}
              kits={data.Kits}
              maintenance={maintenance}
              scale={scale}
              side="left"
              materialSelected={materialSelected}
              onPanelClick={onPanelClick}
              mode={mode}
              presentation={presentation}
              heatMapData={heatMapData}
              selected={selected}
              type="report"
            />

            <DeckPanels
              data={data}
              maintenance={maintenance}
              materialSelected={materialSelected}
              scale={scale}
              onPanelClick={onPanelClick}
              mode={mode}
              presentation={presentation}
              heatMapData={heatMapData}
              selected={selected}
              type="report"
            />

            <SideLiner
              data={sideLiners.left}
              kits={data.Kits}
              maintenance={maintenance}
              scale={scale}
              side="right"
              materialSelected={materialSelected}
              onPanelClick={onPanelClick}
              mode={mode}
              presentation={presentation}
              heatMapData={heatMapData}
              selected={selected}
              type="report"
            />
          </Box>
        </Stack>
      </Stack>
    </Box>
  )
}

export default DeckModelReportPre
